export class FoodItems {
    public food: Phaser.GameObjects.Image;
    public rect: Phaser.Geom.Rectangle;
    public follow: boolean;
    public foodTexture: string;
   
    constructor(food: Phaser.GameObjects.Image, rect: Phaser.Geom.Rectangle, follow: boolean, foodTexture: string) {
        this.food = food;
        this.rect = rect;
        this.follow = follow;
        this.foodTexture = foodTexture;
    }
}



// WEBPACK FOOTER //
// ./src/games/DinerGame/objects/Food.ts